import userService from '../services/userServices';
import { generateKpiResponse } from '../components/mec/osnd/SampleData';

export const kpiViewRequest = (json) => ({ type: 'KPI_VIEW_REQUEST', json });
export const kpiViewSuccess = (data) => ({
    type: 'KPI_VIEW_SUCCESS',
    data
});

export const kpiLastUpdatedTime = (kpiMetricLastUpdateDate) => ({
    type: 'KPI_VIEW_LAST_UPDATED_TIME',
    kpiMetricLastUpdateDate
});

export const kpiViewApiError = (message, form) => ({ type: 'KPI_VIEW_API_ERROR', message, form });

export const kpiThresoldModifyRequest = (file) => ({ type: 'KPI_THRESOLD_MODIDY_REQUEST', file });
export const kpiThresoldModifySuccess = (data) => ({ type: 'KPI_THRESOLD_MODIDY_SUCCESS', data });
export const kpiThresoldModifyApiError = (message, form) => ({ type: 'KPI_THRESOLD_MODIDY_API_ERROR', message, form });

export const kpiThresoldDefaultRequest = (file) => ({ type: 'THRESOLD_DEFAULT_REQUEST', file });
export const kpiThresoldDefaultSuccess = (data) => ({ type: 'THRESOLD_DEFAULT_SUCCESS', data });
export const kpiThresoldDefaultApiError = (message, form) => ({ type: 'THRESOLD_DEFAULT_API_ERROR', message, form });

// EXFO feture
export const kpiViewExfoRequest = (json) => ({ type: 'KPI_VIEW_EXFO_REQUEST', json });
export const kpiViewExfoSuccess = (data) => ({
    type: 'KPI_VIEW_EXFO_SUCCESS',
    data
});
export const kpiViewExfoApiError = (message, form) => ({ type: 'KPI_VIEW_EXFO_API_ERROR', message, form });

export const kpiThresoldModifyExfoRequest = (file) => ({ type: 'KPI_THRESOLD_MODIDY_EXFO_REQUEST', file });
export const kpiThresoldModifyExfoSuccess = (data) => ({ type: 'KPI_THRESOLD_MODIDY_EXFO_SUCCESS', data });
export const kpiThresoldModifyExfoApiError = (message, form) => ({ type: 'KPI_THRESOLD_MODIDY_EXFO_API_ERROR', message, form });

export const kpiThresoldDefaultExfoRequest = (file) => ({ type: 'THRESOLD_DEFAULT_EXFO_REQUEST', file });
export const kpiThresoldDefaultExfoSuccess = (data) => ({ type: 'THRESOLD_DEFAULT_EXFO_SUCCESS', data });
export const kpiThresoldDefaultExfoApiError = (message, form) => ({ type: 'THRESOLD_DEFAULT_EXFO_API_ERROR', message, form });

export const downloadGenerateReportRequest = (file) => ({ type: 'DOWNLOAD_REPORT_REQUEST', file });
export const downloadGenerateReportSuccess = (data) => ({ type: 'DOWNLOAD_REPORT_SUCCESS', data });
export const downloadGenerateReportApiError = (message, form) => ({ type: 'DOWNLOAD_REPORT_API_ERROR', message, form });

export const graphDataCoreRequest = (json1, json2, json3, json4, json5, json6, json7) => ({
    type: 'GRAPH_DATA_CORE_REQUEST',
    json1,
    json2,
    json3,
    json4,
    json5,
    json6,
    json7
});
export const graphDataCoreSuccess = (data) => ({ type: 'GRAPH_DATA_CORE_SUCCESS', data });
export const graphDataCoreApiError = (message, form) => ({ type: 'GRAPH_DATA_CORE_API_ERROR', message, form });

export const graphDataRadioRequest = (json1, json2, json3, json4, json5, json6) => ({
    type: 'GRAPH_DATA_RADIO_REQUEST',
    json1,
    json2,
    json3,
    json4,
    json5,
    json6
});
export const sloGraphDataRadioRequest =
    (
        json1,
        json2,
        json3,
        json4,
        json5,
        json6,
        json7,
        json8,
        json9,
        json10,
        json11,
        json12,
        json13,
        json14,
        json15,
        json16
    ) => ({
    type: 'SLO_GRAPH_DATA_RADIO_REQUEST',
    json1,
    json2,
    json3,
    json4,
    json5,
    json6,
    json7,
    json8,
    json9,
    json10,
    json11,
    json12,
    json13,
    json14,
    json15,
    json16
});
export const graphDataRadioSuccess = (data) => ({ type: 'GRAPH_DATA_RADIO_SUCCESS', data });
export const sloGraphDataRadioSuccess = (data) => ({ type: 'SLO_GRAPH_DATA_RADIO_SUCCESS', data });
export const graphDataRadioApiError = (message, form) => ({ type: 'GRAPH_DATA_RADIO_API_ERROR', message, form });
export const sloGraphDataRadioApiError = (message, form) => ({ type: 'SLO_GRAPH_DATA_RADIO_API_ERROR', message, form });

export const kpiUsageRequest = (file) => ({ type: 'KPI_USAGE_REQUEST', file });
export const kpiUsageViewApiSuccess = (data) => ({ type: 'KPI_USAGE_VIEW_API_SUCCESS', data });
export const kpiUsageViewApiError = (message, form) => ({ type: 'KPI_USAGE_VIEW_API_ERROR', message, form });

export const getInstancesByRegionRequest = (region) => ({ type: 'GET_INSTANCES_BY_REGION_REQUEST', region });
export const getInstancesByRegionSuccess = (data) => ({ type: 'GET_INSTANCES_BY_REGION_SUCCESS', data });
export const getInstancesByRegionApiError = (message, form) => ({ type: 'GET_INSTANCES_BY_REGION_API_ERROR', message, form });

export const getCloudWatchKpiMetricsRequest = (region) => ({ type: 'GET_CLOUDWATCH_KPI_METRICS_REQUEST', region });
export const getCloudWatchKpiMetricsSuccess = (data) => ({ type: 'GET_CLOUDWATCH_KPI_METRICS_SUCCESS', data });
export const getCloudWatchKpiMetricsApiError = (message, form) => ({ type: 'GET_CLOUDWATCH_KPI_METRICS_API_ERROR', message, form });

export const kpisView = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(kpiViewRequest(json));

        userService.kpiView(json).then(
            (response) => {
                const { status } = response;
                const { kpiMetricLastUpdateDate, overallKPIS = [], defaultOverallKPIS = [], totalDeviceCount = 0 } = response.data;
                const data = overallKPIS;
                const defaultData = defaultOverallKPIS;
                dispatch(kpiViewSuccess(data));
                dispatch(kpiLastUpdatedTime(kpiMetricLastUpdateDate));
                resolve({ responseStatus: status, responseData: data, kpiMetricLastUpdateDate, defaultData, totalDeviceCount });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(kpiViewApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const kpisThresoldModify = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(kpiThresoldModifyRequest(json));

        userService.kpiThresoldModify(json).then(
            (response) => {
                // const { kpiDataApi, updatedDate } = response.data;
                const { status, data } = response;
                dispatch(kpiThresoldModifySuccess(data));
                resolve({ responseStatus: status, responseData: data });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(kpiThresoldModifyApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const kpiThresoldDefault = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(kpiThresoldDefaultRequest(json));
        userService.kpiThresoldDefault(json).then(
            (response) => {
                const { status, data } = response;
                dispatch(kpiThresoldDefaultSuccess(data));
                resolve({ responseStatus: status, responseData: data });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(kpiThresoldDefaultApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const kpisExfoView = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(kpiViewExfoRequest(json));

        userService.kpiExfoView(json).then(
            (response) => {
                const { status } = response;
                const { kpiMetricLastUpdateDate, overallKPIS = [], defaultOverallKPIS = [], totalDeviceCount = 0 } = response.data;
                const data = overallKPIS;
                const defaultData = defaultOverallKPIS;
                dispatch(kpiViewExfoSuccess(data));
                dispatch(kpiLastUpdatedTime(kpiMetricLastUpdateDate));
                resolve({ responseStatus: status, responseData: data, kpiMetricLastUpdateDate, defaultData, totalDeviceCount });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(kpiViewExfoApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const kpisThresoldExfoModify = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(kpiThresoldModifyExfoRequest(json));

        userService.kpiThresoldExfoModify(json).then(
            (response) => {
                // const { kpiDataApi, updatedDate } = response.data;
                const { status, data } = response;
                dispatch(kpiThresoldModifyExfoSuccess(data));
                resolve({ responseStatus: status, responseData: data });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(kpiThresoldModifyExfoApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const kpiThresoldExfoDefault = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(kpiThresoldDefaultExfoRequest(json));
        userService.kpiThresoldExfoDefault(json).then(
            (response) => {
                const { status, data } = response;
                dispatch(kpiThresoldDefaultExfoSuccess(data));
                resolve({ responseStatus: status, responseData: data });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(kpiThresoldDefaultExfoApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const generateReportCsv = (progressCallback, setupCancelerCallback, locationId) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(downloadGenerateReportRequest());

        userService.downloadGenerateReport(progressCallback, setupCancelerCallback, locationId).then(
            (response) => {
                const blob = response.data;

                dispatch(downloadGenerateReportSuccess());

                resolve({ blob, canceled: false });
            },
            ({ error, canceled }) => {
                if (canceled === true) {
                    return resolve({ canceled: true });
                }

                const { response = {} } = error;
                const { message, form = {} } = response.data;

                dispatch(downloadGenerateReportApiError(message, form));

                return reject({ message, form });
            }
        );
    });

export const graphDataCore = (json1, json2, json3, json4, json5, json6, json7) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(graphDataCoreRequest(json1, json2, json3, json4, json5, json6, json7));

        userService.graphDataCore(json1, json2, json3, json4, json5, json6, json7).then(
            (...responses) => {
                // const { kpiDataApi, updatedDate } = response.data;
                const { status } = responses[0][0];

                const metrixMap = responses[0].map(({ data }) => {
                    if (data && data.metrics) {
                        const dataTemp = [];
                        let name;
                        data.metrics.forEach((val) => {
                            name = val.metric;
                            dataTemp.push(...val.values);
                        });

                        return { metric: name, values: dataTemp };
                    }
                }); // .reduce((acc, val) => ({ ...acc, [val.metric.name]: val.values }), {});
                const metrix = metrixMap.reduce((acc, val) => {
                    if (val && val.metric && val.values) return { ...acc, [val.metric.name]: val.values };
                }, {});
                if (metrix) {
                    const metrixData = Object.keys(metrix).map((key) => ({ key, arrVal: metrix[key] }));
                    const sortedData = metrixData.sort(function (a, b) {
                        return a.arrVal.time - b.arrVal.time;
                    });
                    dispatch(graphDataCoreSuccess(sortedData));
                    resolve({ responseStatus: status, responseData: sortedData });
                } else {
                    dispatch(graphDataRadioApiError('metrix data not available', null));
                    return reject({ message: 'metrix data not available', form: null });
                }
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(graphDataCoreApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const graphDataRadio = (json1, json2, json3, json4, json5, json6) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(graphDataRadioRequest(json1, json2, json3, json4, json5, json6));

        userService.graphDataRadio(json1, json2, json3, json4, json5, json6).then(
            (...responses) => {
                const { status } = responses[0][0] || responses[0][1] || responses[0][2] || responses[0][3] || responses[0][4] || responses[0][5];
                const metrixMap = responses[0].map((response) => {
                    if (response?.data?.metrics) {
                        const dataTemp = [];
                        let name;
                        response.data.metrics.forEach((val) => {
                            name = val.metric;
                            dataTemp.push(...val.values);
                        });
                        return { metric: name, values: dataTemp };
                    }
                });
                const metrix = metrixMap
                    .filter((x) => x)
                    .reduce((acc, val) => {
                        if (val && val.metric && val.values) return { ...acc, [val.metric.name]: val.values };
                    }, {});
                if (metrix) {
                    const metrixData = Object.keys(metrix).map((key) => ({ key, arrVal: metrix[key] }));
                    const sortedData = metrixData.sort(function (a, b) {
                        return a.arrVal.time - b.arrVal.time;
                    });
                    dispatch(graphDataRadioSuccess(sortedData));
                    resolve({ responseStatus: status, responseData: sortedData });
                } else {
                    dispatch(graphDataRadioApiError('metrix data not available', null));
                    return reject({ message: 'metrix data not available', form: null });
                }
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(graphDataRadioApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const sloGraphDataRadio =
    (
        json1,
        json2,
        json3,
        json4,
        json5,
        json6,
        json7,
        json8,
        json9,
        json10,
        json11,
        json12,
        json13,
        json14,
        json15,
        json16
    ) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(
            sloGraphDataRadioRequest(
                json1,
                json2,
                json3,
                json4,
                json5,
                json6,
                json7,
                json8,
                json9,
                json10,
                json11,
                json12,
                json13,
                json14,
                json15,
                json16
            )
        );

        userService
            .sloGraphDataRadio(
                json1,
                json2,
                json3,
                json4,
                json5,
                json6,
                json7,
                json8,
                json9,
                json10,
                json11,
                json12,
                json13,
                json14,
                json15,
                json16
            ).then(
            (...responses) => {
                const { status } =
                    responses[0][0] ||
                    responses[0][1] ||
                    responses[0][2] ||
                    responses[0][3] ||
                    responses[0][4] ||
                    responses[0][5] ||
                    responses[0][6] ||
                    responses[0][7] ||
                    responses[0][8] ||
                    responses[0][9] ||
                    responses[0][10] ||
                    responses[0][11] ||
                    responses[0][12] ||
                    responses[0][13] ||
                    responses[0][14] ||
                    responses[0][15];
                const metrixMap = responses[0].map((response) => {
                    if (response?.data?.metrics) {
                        const dataTemp = [];
                        let name;
                        response.data.metrics.forEach((val) => {
                            name = val.metric;
                            dataTemp.push(...val.values);
                        });
                        return { metric: name, values: dataTemp };
                    }
                });
                const metrix = metrixMap
                    .filter((x) => x)
                    .reduce((acc, val) => {
                        if (val && val.metric && val.values) return { ...acc, [val.metric.name]: val.values };
                    }, {});
                if (metrix) {
                    const metrixData = Object.keys(metrix).map((key) => ({ key, arrVal: metrix[key] }));
                    const sortedData = metrixData.sort(function (a, b) {
                        return a.arrVal.time - b.arrVal.time;
                    });
                    dispatch(sloGraphDataRadioSuccess(sortedData));
                    resolve({ responseStatus: status, responseData: sortedData });
                } else {
                    dispatch(sloGraphDataRadioApiError('metrix data not available', null));
                    return reject({ message: 'metrix data not available', form: null });
                }
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(sloGraphDataRadioApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const kpisUsageView = (json) => (dispatch) =>
    new Promise((resolve, reject) => {
        //dispatch(kpiUsageRequest(json));
        userService.kpiOverallUsage(json).then(
            (response) => {
                const { status } = response;
                const { kpiUsageLastUpdateDate, topDevices = [] } = response.data;
                const data = topDevices;
                console.log(kpiUsageLastUpdateDate);
                // dispatch(kpiUsageViewApiSuccess(data));
                resolve({ responseStatus: status, responseData: data, lastUpdatedTime: kpiUsageLastUpdateDate });
            },
            (error) => {
                const { message, form = {} } = error.data;
                // dispatch(kpiUsageViewApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const getCloudWatchKpiMetrics = (payload) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(getCloudWatchKpiMetricsRequest(payload));

        userService.fetchCloudWatchMetrics(payload).then(
            (response) => {
                const { data } = response;
                dispatch(getCloudWatchKpiMetricsSuccess(data));
                resolve(data);
            },
            (error) => {
                // mocked API call for local development
                // const mockedData = generateKpiResponse(50);
                // dispatch(getCloudWatchKpiMetricsSuccess(mockedData));
                // resolve(mockedData);
                const { message, form = {} } = error.data;
                dispatch(getCloudWatchKpiMetricsApiError(message, form));
                return reject({ message, form });
            }
        );
    });
